import { ParseKeys } from "i18next";
import { QuoteApprovalStatus } from "generated/graphql";

export type QuoteTab =
  | "all"
  | "starred"
  | "unprocessed"
  | "completed"
  | "archived";

export const QUOTE_TABS: { label: ParseKeys<"quotes">; path: QuoteTab }[] = [
  { label: "tabs.all", path: "all" },
  { label: "tabs.starred", path: "starred" },
  { label: "tabs.unprocessed", path: "unprocessed" },
  { label: "tabs.completed", path: "completed" },
  { label: "tabs.archived", path: "archived" },
];

export const EMPTY_TAB_TEXT: Record<QuoteTab, ParseKeys<"quotes">> = {
  all: "empty.all",
  starred: "empty.starred",
  unprocessed: "empty.unprocessed",
  completed: "empty.completed",
  archived: "empty.archived",
};

interface TabbedQuote {
  starred: boolean;
  archived: boolean;
  viewed: boolean;
  approvalStatus: QuoteApprovalStatus;
}

/**
 * Whether a quote belongs on a tab. Archived quotes only show under Archived;
 * "unprocessed" means not opened since the vendor last sent it, "completed"
 * means approved.
 */
export const isOnTab = (quote: TabbedQuote, tab: QuoteTab): boolean => {
  if (tab === "archived") {
    return quote.archived;
  }
  if (quote.archived) {
    return false;
  }

  switch (tab) {
    case "starred":
      return quote.starred;
    case "unprocessed":
      return !quote.viewed;
    case "completed":
      return quote.approvalStatus === QuoteApprovalStatus.Approved;
    default:
      return true;
  }
};

export const isQuoteTab = (tab: string): tab is QuoteTab =>
  QUOTE_TABS.some(({ path }) => path === tab);
